import { VeltProvider, VeltComments, VeltCommentsSidebar} from '@veltdev/react';
import YourAuthComponent from './components/YourAuthComponent';
import YourDocument from './components/YourDocument';
import Roadmap from './components/Roadmap'
import Table from './components/Table'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link
} from "react-router-dom";


function App() {


  return (
    <Router>
    <VeltProvider apiKey="XT2TkGnWRopZ6Xemdnb3">
      <VeltComments textMode={true} sidebarButtonOnCommentDialog={true} autoCategorize={true}/>
      <VeltCommentsSidebar />
      <Routes>
          
          <Route exact path="/roadmap" element={<Roadmap/>}>
          </Route>

          <Route exact path="/table" element={<Table/>}>
          </Route>
          <Route exact path="/" element={<YourDocument/>}>
          </Route>
        </Routes>
    </VeltProvider>
    </Router>

  );
}

export default App;

